import { roundToTwo } from '@/utils/helpers';

export default {
  props: {
    amount: {
      type: Number,
      required: false,
    },
    fee: {
      type: Number,
      required: false,
    },
    total: {
      type: Number,
      required: false,
    },
    isBankTransfer: {
      type: Boolean,
      default: false,
    },
    isDeposit: {
      type: Boolean,
      default: false,
    },
    flatFeeAmount: {
      type: Number,
      required: false,
    },
    percentageFeeAmount: {
      type: Number,
      required: false,
    },
    plaidAccount: {
      type: Object,
      required: false,
      default: null,
    },
  },
  computed: {
    flatFeeAmountRounded() {
      return roundToTwo(this.flatFeeAmount);
    },
    percentageFeeAmountRounded() {
      return roundToTwo(this.percentageFeeAmount);
    },
    feeRounded() {
      return roundToTwo(this.fee || 0);
    },
    totalRounded() {
      return roundToTwo(this.total);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/amount-info/amount-info.js